module.exports = __webpack_public_path__ + "static/media/protect.73a68ecc.svg";